import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'nlf-user-notifications',
  templateUrl: './user-notifications.component.html',
  styleUrls: ['./user-notifications.component.css']
})
export class NlfUserNotificationsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
